export default __webpack_public_path__ + "static/media/aceclo.661e8832.jpeg";